import { HocuspocusProvider } from '@hocuspocus/provider';
import { Doc } from 'yjs';
import { Lyrics2Configuration } from 'types/lyrics.types';
import { createCursorElement } from 'app/components/Song/Lyrics/TextEditor/utils';
import { getExtensions } from '@session-clients/lyrics-extensions';
import { LyricsConfigError } from 'app/components/Song/Lyrics/TextEditorErrorBoundary';

interface Props {
  config: Lyrics2Configuration;
  provider: HocuspocusProvider;
  yDoc: Doc;
}

/*
    IMPORTANT!!!
    Any change around extensions must be understood and aligned with Mobile team.
    Mismatch between extensions in different Clients might result in data loss.
*/

export const getLyricsEditorExtensions = ({
  config,
  provider,
  yDoc: document,
}: Props) => {
  try {
    const baseExtensions = getExtensions(config, {
      provider,
      document,
      render: createCursorElement,
    });
    const clientExtensions = [
      // add custom extensions
    ];
    return [...baseExtensions, ...clientExtensions];
  } catch (e: any) {
    const missingExtension = (e?.message || '').includes(
      'Unsupported extension'
    );
    if (missingExtension) {
      throw new Error(LyricsConfigError.UNSUPPORTED_EXTENSION_FOUND);
    }
    throw new Error(LyricsConfigError.UNKNOWN);
  }
};
